export const environment = {
    env: 'PROD',
    production: true,
    serverBaseUrl: 'https://api.preplan.notifypetsatpeace.com',
    serverUrl: 'https://api.preplan.notifypetsatpeace.com'
};
